"use client"

import { useContext, useState } from 'react'
import { AppContext, Project } from "@/App"

interface FrmMultiProjectDashboardProps {
    setDialogOpen?: (open: boolean) => void;
    selectedProjects: number[];
    setSelectedProjects: (projects: number[]) => void;
    projects?: Project[]; // Optional override for demo mode
}

const FrmMultiProjectDashboard = ({setDialogOpen, selectedProjects, setSelectedProjects, projects} : FrmMultiProjectDashboardProps) => {
    const app = useContext(AppContext);
    const [localSelectedProjects, setLocalSelectedProjects] = useState<number[]>(selectedProjects);
    
    // Use provided projects or fall back to app projects
    const availableProjects = projects || app.projects;

    function onSubmit() {
        if (localSelectedProjects.length === 0) {
            alert("Please select at least one project to view the dashboard.");
            return;
        }
        setDialogOpen?.(false);
        setSelectedProjects(localSelectedProjects);
    }

  return (
    <div className="p-4">
        <div className="flex items-center mb-6">
            <div className="flex items-center">
            <input
                type="checkbox"
                id="select-all"
                className="checkbox-default"
                checked={localSelectedProjects.length === availableProjects.length}
                onChange={(e) => {
                if (e.target.checked) {
                    // Select all projects
                    setLocalSelectedProjects(availableProjects.map(p => p.id));
                } else {
                    // Deselect all projects
                    setLocalSelectedProjects([]);
                }
                }}
            />
            <label htmlFor="select-all" className="text-lg font-medium cursor-pointer">Select All</label>
            </div>
        </div>
        <div className="mb-6 space-y-3">
            {availableProjects.map(project => (
                <div key={project.id} className="flex items-center py-2">
                    <input
                        type="checkbox"
                        id={`project-${project.id}`}
                        className="checkbox-default"
                        checked={localSelectedProjects.includes(project.id)}
                        onChange={(e) => {
                            if (e.target.checked) {
                                setLocalSelectedProjects([...localSelectedProjects, project.id]);
                            } else {
                                setLocalSelectedProjects(localSelectedProjects.filter(id => id !== project.id));
                            }
                        }}
                    />
                    <label htmlFor={`project-${project.id}`} className="text-base cursor-pointer flex-1">{project.name}</label>
                </div>
            ))}
        </div>
        <div className="flex">
            <button
                onClick={onSubmit}
                className="button-default mx-auto"
            >
                Update Dashboard
            </button>
        </div>
    </div>
  )
}

export default FrmMultiProjectDashboard